import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { SalesShellComponent } from './sales-shell/sales-shell.component';
import { RouteApplicationStartupResolveService } from '@admin/core/route-application-startup-resolve.service';
import { MonthlyPlanComponent } from './monthly-plan/monthly-plan.component';
import { MonthlyPlanReportComponent } from './monthly-plan-report/monthly-plan-report.component';
import { SalesLookupResolveService } from './shared/services/sales-lookup-resolve.service';
import { AuthGuard } from '../core/auth.guard';

const routes: Routes = [
  {
    path: 'sales',
    component: SalesShellComponent,
    canActivate: [AuthGuard],
    resolve: {
      appData: RouteApplicationStartupResolveService,
      lookupData: SalesLookupResolveService,
    },
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'monthly-plan',
      },
      {
        path: 'monthly-plan',
        component: MonthlyPlanComponent,
      },
      {
        path: 'monthly-plan-report',
        component: MonthlyPlanReportComponent,
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class SalesRoutingModule {}
